// extracted by mini-css-extract-plugin
export default {"palyerRatingFooter":"PlayersRatingTable_palyerRatingFooter_ac9d9"};